<template>
  <div class="row gx-2">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
      <div class="d-flex flex-row-reverse col-sm-12">
        <div class="p-2 col-sm-4">
          <button class="btn btn-dark btn-sm"  @click="downloadPass">
            <font-awesome-icon icon="download" /> <span style="font-size:smaller;">Download</span>
          </button>
        </div>
        <div :class="is_ios ? 'p-2 col-sm-8': 'col-sm-8'">
          <img  src="../assets/apple_wallet.svg"
                @click="addToAppleWallet"
                role="button"
                v-if="is_ios"/>
              <span 
                  v-if="is_android"
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
          <save-to-google-pay-button 
              :jwt="jwt"
              height="standard"
              size=" matchparent"
              theme="dark"
              @success="onGooglePaySuccess"
              @failure="onGooglePayFailure"
              v-if="is_android && jwt"
             >
          </save-to-google-pay-button> 
        </div>
      </div>
    </div>
    <div class="col-sm-3"></div>
  </div>
  <div class="row no-gutters" ref="downloadcontent">
    <!--<template v-for="(profile, profile_idx) in profiles" :key="profile.user_id">-->
    <div class="col-sm-3"></div>
    <div class="col-sm-6">
      <!--<div class="card text-center" :id="profile_idx">-->
      <div class="card text-center">
        <div class="card-header bg-dark text-white">
          <img src="../assets/logo.png" alt="ARC LE SALON" height="36" />
        </div>
        <div class="text-center pt-2">
          <h6 class="card-title"><strong>GUEST PASS</strong></h6>
          <img class="w-75" :src="profile.qr" border="1" alt="QR Code" />
        </div>
        <div class="card-body">
          <h6 class="card-title">
            <strong>{{ profile.name }}</strong>
          </h6>
          <p class="card-text">Guest of {{ profile.invited_by }}</p>
          <h6 class="card-text">Valid: {{ profile.start_date }}</h6>
        </div>
        <div class="card-footer bg-dark">
          <p class="card-text text-white">
            <small>
              Photo ID maybe requested and entry is at the discretion of
              management.</small
            >
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-3"></div>
    <!--</template>-->
  </div>
</template>

<script>
import Html2Canvas from "html2canvas";
import { isMobile, isIOS, isBrowser, isFirefox, isAndroid } from "mobile-device-detect";
import axios from "axios";
import '@google-pay/save-button-element';
import WalletService from "../services/wallet.service";

export default {
  name: "GuestPass",
  props: ["profile"],

  components: {
    Html2Canvas,
  },

  mounted() {  
    if(this.is_android) {
      this.loading = true;
      this.getGooglePayJwt();
    } else {
       this.loading = false;
    }
  },
  data() {
    return {
      guest_profiles: this.profile,
      id: this.profile.id,
      base_url: process.env.VUE_APP_PROFILE_BASE_URL,
      seen: true,
      is_mobile: isMobile,
      is_ios: isIOS,
      is_browser: isBrowser,
      is_firefox: isFirefox,
      is_android: isAndroid,
      jwt: null,
      loading: false
    };
  },
  methods: {
    async downloadPass() {
      this.seen = false;

      const el = this.$refs.downloadcontent;

      const options = {
        type: "dataURL",
      };
      const printCanvas = await Html2Canvas(el, options);

      const link = document.createElement("a");
      link.setAttribute("download", "arclesalon_guest_pass.png");
      link.setAttribute(
        "href",
        printCanvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream")
      );
      link.click();
      this.seen = true;
    },
    addToAppleWallet() {
      var full_api_url =
        process.env.VUE_APP_API_BASE_URL + "wallet/appleguest?id=" + this.id;

      axios({
        url: full_api_url,
        method: "GET",
        responseType: "blob",
        headers: { access_token: process.env.VUE_APP_API_KEY },
      }).then((res) => {
        var FILE = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.apple.pkpass",
          })
        );

        var docUrl = document.createElement("a");
        docUrl.href = FILE;
        docUrl.setAttribute("download", "guest.pkpass");
        document.body.appendChild(docUrl);
        docUrl.click();
      });
    },
    getGooglePayJwt() {      
      WalletService.getGoogleGuestPassJwt(this.profile.id).then(
        (response) => {
          this.message = "";
          this.loading = false;
          this.jwt = response;
        },
        (error) => {
          this.loading = false;
          this.message =
              (error.response &&
                error.response.data &&
                error.response.data.detail) ||
              error.response.data.detail ||
              error.toString();
          
        }
      );
    },
    onGooglePaySuccess: () => {
      console.log('success');
    },
    onGooglePayFailure: event => {
      console.error('failure', event.detail);
    },
  },
};
</script>

<style scoped>
.enabled,
.found {
  color: green;
  font-weight: bold;
}

.disabled {
  color: red;
  font-weight: bold;
}
</style>
